const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccumulatedVolts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M199.223 305.306h38.098v68.091a9.999 9.999 0 0 0 10.001 10.001c3.48 0 6.794-1.825 8.622-4.937L321.4 267.004a10 10 0 0 0-8.623-15.064H274.68v-68.09a9.999 9.999 0 0 0-7.376-9.649 9.998 9.998 0 0 0-11.247 4.585L190.6 290.242a10 10 0 0 0 8.623 15.064Zm55.457-84.682v41.316c0 5.523 4.477 10 10 10h30.628l-37.987 64.683v-41.317c0-5.523-4.478-10-10-10h-30.628l37.987-64.682ZM374.685 288.626h10.592v10.592c0 5.523 4.478 10 10 10s10-4.477 10-10v-10.592h10.593c5.522 0 10-4.477 10-10s-4.478-10-10-10h-10.593v-10.593c0-5.523-4.478-10-10-10s-10 4.477-10 10v10.593h-10.592c-5.522 0-10 4.477-10 10s4.477 10 10 10ZM96.131 288.624h41.185c5.523 0 10-4.477 10-10s-4.477-10-10-10H96.131c-5.522 0-10 4.477-10 10s4.477 10 10 10Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(.07813 0 0 .07813 7.5 7.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 152.974c5.522 0 10-4.477 10-10V90.696c0-5.523-4.478-10-10-10h-46.909V45.449c0-5.523-4.477-10-10-10h-99.629c-5.522 0-10 4.477-10 10v35.247h-34.256c-5.522 0-10 4.477-10 10s4.478 10 10 10H492v32.278H20v-32.278h190.794c5.523 0 10-4.477 10-10s-4.477-10-10-10h-34.256V45.449c0-5.523-4.478-10-10-10H66.909c-5.523 0-10 4.477-10 10v35.247H10c-5.523 0-10 4.477-10 10v52.278c0 5.523 4.477 10 10 10h19.743v251.298H10c-5.523 0-10 4.477-10 10v52.279c0 5.523 4.477 10 10 10h492c5.522 0 10-4.477 10-10v-52.279c0-5.523-4.478-10-10-10h-19.743V152.974H502ZM355.462 80.696V55.449h79.629v25.247h-79.629ZM76.909 55.449h79.629v25.247H76.909V55.449ZM492 456.551H20v-32.279h472v32.279Zm-29.743-52.279H49.743V152.974h412.514v251.298Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(.07813 0 0 .07813 7.5 7.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.95 94.52c1.579 3.791 5.434 6.317 9.555 6.174 4.116-.143 7.818-2.885 9.144-6.783 1.343-3.947.024-8.464-3.255-11.046-3.287-2.588-7.927-2.866-11.491-.661-4.102 2.54-5.809 7.861-3.953 12.316Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(.07813 0 0 .07813 7.5 7.5)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccumulatedVolts);
export default __webpack_public_path__ + "static/media/accumulated-volts.d834f2636bb4c09d5b4206f7adec5d46.svg";
export { ForwardRef as ReactComponent };